import React, { Component } from 'react';
import Firebase from 'firebase'
import {formatCurrency} from '../assets/js/formatPattern'

class SectionPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataProduct: null,
      dataContact: []
    }
    this.getValueFeature = this.getValueFeature.bind();
  }

  componentDidMount() {
    Firebase.database().ref('product').on('value', data => {
      this.setState({dataProduct: data.val()})
    })
    Firebase.database().ref('contact').on('value', data => {
      this.setState({dataContact: data.val()})
    })
  }

  getValueFeature(val) {
    let data = []
    let elFeature = []
    val.forEach((element, index) => {
      data[index] = element.value
    });
    data.forEach((element, index) => {
      elFeature[index] = <li key={index}>{element}</li>
    });
    return elFeature
  }
  
  render() { 
    let {dataProduct, dataContact} = this.state
    let pricing = []
    if (dataProduct) {
      let i = 0
      for (let key in dataProduct) {
        pricing[i] = <div className="col-md-3" data-aos="fade-up" data-aos-delay="100" key={i}>
          <div className="pricing-entry pb-5 text-center">
            <div>
              <h3 className="mb-4">{dataProduct[key].name}</h3>
              <p>
                {
                  formatCurrency(dataProduct[key].price) != 'NaN' ? 
                  <span className="price">Rp {formatCurrency(dataProduct[key].price)}</span>
                  : <span className="price">{dataProduct[key].price}</span>
                }
              </p>
            </div>
            <ul>
              <li>{dataProduct[key].template_name.replace(/,/g, ' / ')}</li>
              <li>{dataProduct[key].domain}</li>
              { this.getValueFeature(dataProduct[key].feature) }
              {
                formatCurrency(dataProduct[key].otherprice) != 'NaN' ? 
                <li>Renewal Rp {formatCurrency(dataProduct[key].otherprice)}/tahun</li>
                : ''
              }
            </ul>
            <p className="button text-center">
              <a href={`https://api.whatsapp.com/send?phone=${dataContact.whatsapp}&text=Halo,%20Saya%20mau%20order%20websitenya%20ya%0A%0ANama:%0AKota:%0ATipe%20website:${dataProduct[key].name}`} target="_blank" className="btn btn-primary px-4 py-3">Order Now</a>
            </p>
          </div>
        </div>
        i++
      }
    }

    return (
      <section className="ftco-section" id="pricing-section">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-12 heading-section text-center" data-aos="fade-up">
              <span className="subheading">Pricing</span>
              <h2 className="mb-4">Pricelist</h2>
              {/* <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p> */}
            </div>
          </div>
          <div className="row" style={{justifyContent: 'space-evenly'}}>
            {pricing}
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionPricing;